import { useState } from "react";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { Input } from "@/components/ui/input";
import { Slider } from "@/components/ui/slider";
import { Badge } from "../components/ui/badge";

export default function SwitchConfiguratorPrototype() {
  const [step, setStep] = useState(1);
  const [room, setRoom] = useState("");
  const [type, setType] = useState("");
  const [wall, setWall] = useState("");
  const [selectedSku, setSelectedSku] = useState("SKU1");
  const [config, setConfig] = useState(["2-Gang", "USB"]);
  const [plateColor, setPlateColor] = useState("White");
  const recommendations = ["Smart Layout A", "Smart Layout B", "Smart Layout C"];
  return (
    <div className="max-w-4xl mx-auto p-6 space-y-6">
      <Card>
        <CardContent className="space-y-4">
          <div className="text-xl font-semibold">Step {step}: Choose Your Setup</div>
          {step === 1 && (
            <div className="space-y-2">
              <div>
                <div className="mb-1 font-medium">Room Type</div>
                <div className="flex gap-2">
                  {['Bedroom', 'Living Room', 'Kitchen'].map(r => (
                    <Button key={r} onClick={() => setRoom(r)} variant={room === r ? 'default' : 'outline'}>{r}</Button>
                  ))}
                </div>
              </div>
              <div>
                <div className="mb-1 font-medium">Switch Type</div>
                <div className="flex gap-2">
                  {['Standard', 'Smart'].map(t => (
                    <Button key={t} onClick={() => setType(t)} variant={type === t ? 'default' : 'outline'}>{t}</Button>
                  ))}
                </div>
              </div>
              <div>
                <div className="mb-1 font-medium">Wall Color</div>
                <div className="flex gap-2">
                  {['Light', 'Dark'].map(w => (
                    <Button key={w} onClick={() => setWall(w)} variant={wall === w ? 'default' : 'outline'}>{w}</Button>
                  ))}
                </div>
              </div>
              <Button className="mt-4" onClick={() => {
                setSelectedSku("SKU18");
                setStep(2);
              }}>Next</Button>
            </div>
          )}
          {step === 2 && (
            <div className="space-y-4">
              <div className="font-medium">Current SKU: {selectedSku}</div>
              <div className="flex gap-2">
                {config.map(item => (
                  <Badge key={item}>{item}</Badge>
                ))}
              </div>
              <div className="flex gap-2 mt-2">
                <Button onClick={() => setConfig(["2-Gang"])}>Remove USB</Button>
                <Button onClick={() => setPlateColor("Matte Grey")}>Change Plate to Matte Grey</Button>
              </div>
              <Button onClick={() => {
                setSelectedSku("SKU27");
                setStep(3);
              }} className="mt-4">Confirm Configuration</Button>
            </div>
          )}
          {step === 3 && (
            <div className="space-y-4">
              <div className="text-lg font-semibold">Scan to preview SKU: {selectedSku}</div>
              <div className="rounded bg-gray-100 p-4 text-center">[QR CODE for {selectedSku}]</div>
              <div className="font-medium">Need help?</div>
              <div className="flex gap-2">
                {recommendations.map(r => (
                  <Button key={r} variant="outline">{r}</Button>
                ))}
              </div>
              <div className="flex gap-4 mt-4">
                <Button>Add to Cart</Button>
                <Button variant="outline">Share</Button>
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}